exports = module.exports = require("../../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, "/**\n* DEFINE VARIABLES\n*/\n@media screen and (max-width: 610px) {\n.col-md-6 {\n    width: 260px;\n}\n}\n.header-left-image {\n  width: auto;\n  min-width: 103px;\n}\n.app-header.navbar .navbar-brand {\n  width: 135px;\n  height: 69px;\n  padding: unset;\n  margin-right: unset;\n  border-bottom: none;\n  background-size: cover;\n}\n", ""]);

// exports



//////////////////
// WEBPACK FOOTER
// ./node_modules/css-loader?{"minimize":false,"sourceMap":false}!./node_modules/vue-loader/lib/style-compiler?{"vue":true,"id":"data-v-3e30d620","scoped":false,"hasInlineConfig":false}!./node_modules/less-loader/dist/cjs.js?{"sourceMap":false}!./node_modules/vue-loader/lib/selector.js?type=styles&index=0!./src/components/authorization/login/LoginHeader.vue
// module id = 1847
// module chunks = 1